import * as React from 'react';

function SvgCricketTab(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={40} height={30} {...props}>
      <defs>
        <style>{`.cricket_tab_svg__prefix__cls-2{fill:${props.fill}`}</style>
      </defs>
      <g id="cricket_tab_svg__prefix__cricket_tab" transform="translate(-45 -97)">
        <path
          id="cricket_tab_svg__prefix__Rectangle_2035"
          d="M0 0h40v30H0z"
          data-name="Rectangle 2035"
          transform="translate(45 97)"
          fill="none"
        />
        <g
          id="cricket_tab_svg__prefix__cricket_3_"
          data-name="cricket (3)"
          transform="translate(50 96.998)"
        >
          <g
            id="cricket_tab_svg__prefix__Group_2562"
            data-name="Group 2562"
            transform="translate(11.088 11.091)"
          >
            <g id="cricket_tab_svg__prefix__Group_2561" data-name="Group 2561">
              <path
                id="cricket_tab_svg__prefix__Path_5458"
                d="M190.46 189.614a.6.6 0 100 .849.6.6 0 000-.849z"
                className="cricket_tab_svg__prefix__cls-2"
                data-name="Path 5458"
                transform="translate(-189.435 -189.438)"
              />
            </g>
          </g>
          <g
            id="cricket_tab_svg__prefix__Group_2564"
            data-name="Group 2564"
            transform="translate(0 .002)"
          >
            <g id="cricket_tab_svg__prefix__Group_2563" data-name="Group 2563">
              <path
                id="cricket_tab_svg__prefix__Path_5459"
                d="M21.164 18.68l.59-1.375a.586.586 0 00-.113-.634l-1.449-1.527 9.283-8.816.011-.01a1.754 1.754 0 00.481-1.587A5.966 5.966 0 0025.272.036a1.754 1.754 0 00-1.587.481l-.01.011L15 9.667 6.326.528 6.315.517A1.755 1.755 0 004.728.036 5.983 5.983 0 00.034 4.73a1.756 1.756 0 00.481 1.588l.011.011 9.286 8.809-1.452 1.533a.586.586 0 00-.113.634l.59 1.375L.515 27A1.758 1.758 0 103 29.487l8.322-8.321 1.375.59a.586.586 0 00.634-.113L15 20.061l1.668 1.582a.586.586 0 00.634.113l1.375-.59L27 29.487A1.758 1.758 0 1029.485 27zm3.354-17.339a.584.584 0 01.525-.156 4.8 4.8 0 013.774 3.775.585.585 0 01-.156.524l-9.276 8.809-3.585-3.775zM2.172 28.659a.586.586 0 11-.828-.828l.911-.911.828.828zm1.74-1.74l-.829-.828 6.251-6.252a1.748 1.748 0 00.112.2.584.584 0 00.516.516 1.736 1.736 0 00.2.112zM9.475 17.2l1.187-1.253 1.317 1.25-1.754 1.754zm3.33 3.33l-1.75-.751L12.83 18l1.32 1.252zm.124-6.767l6.017 6.017-1.75.75-6.153-5.84-9.7-9.206a.584.584 0 01-.156-.524 4.811 4.811 0 013.771-3.775.585.585 0 01.524.156L20.524 17.2l-.75 1.75-6.017-6.017a.586.586 0 00-.829.829zm13.16 13.159l-6.252-6.251a1.744 1.744 0 00.2-.112.584.584 0 00.516-.516 1.75 1.75 0 00.112-.2l6.251 6.252zm2.568 1.74a.586.586 0 01-.828 0l-.911-.911.828-.828.911.911a.586.586 0 010 .828z"
                className="cricket_tab_svg__prefix__cls-2"
                data-name="Path 5459"
                transform="translate(0 -.002)"
              />
            </g>
          </g>
          <g
            id="cricket_tab_svg__prefix__Group_2566"
            data-name="Group 2566"
            transform="translate(11.397 22.435)"
          >
            <g id="cricket_tab_svg__prefix__Group_2565" data-name="Group 2565">
              <path
                id="cricket_tab_svg__prefix__Path_5460"
                d="M199.6 386a3.6 3.6 0 103.6 3.6 3.607 3.607 0 00-3.6-3.6zm0 6.005a2.4 2.4 0 112.4-2.4 2.4 2.4 0 01-2.4 2.403z"
                className="cricket_tab_svg__prefix__cls-2"
                data-name="Path 5460"
                transform="translate(-196 -386.003)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgCricketTab;
